<template lang="">
    <div >
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="goback()">
                <b-icon icon="arrow-left"></b-icon> {{$route.query.desc}}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
    
                <b-nav-item>
                    <b-button-group>
                        <!-- <b-button variant="info" @click="onListItems">
                                                    <b-icon icon="list" aria-hidden="true" variant="light"></b-icon> ລາຍການ
                                                </b-button> -->
    
                        <!-- <b-button variant="danger" @click="goback()">
                                                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon> ປິດ
                                                </b-button> -->
                    </b-button-group>
    
    
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <b-row class="p-3">
            <b-col>
                <b-button pill variant="outline-secondary" @click="onnewquestion">
                    <b-icon icon="question-circle-fill"></b-icon> ຄຳຖາມ</b-button>
            </b-col>
        </b-row>
        <b-row class="p-3" v-for="(item,index) in items" :key="item._id">
            <b-col>
    
                <b-card no-body>
    
    
                    <b-list-group flush>
                        <b-list-group-item variant="secondary" style="white-space: pre;">  <b-avatar  variant="success"></b-avatar> {{item.description}}</b-list-group-item>
    
                        <b-list-group-item  class="pl-5" href="#" v-for="row in item.answers" :key="row.index">
                            
                            <b-avatar  icon="people-fill"></b-avatar>  <b-link href="#">{{row.create_by}}</b-link> <span>{{row.create_date | formatdate}}</span>
                            <div class="ml-5 " style="white-space: pre;">
                                
                                  {{row.answer}}
                            </div>
                        </b-list-group-item>
                    </b-list-group>
    
    
    
    
                    <b-row>
                        <b-col>
                            <b-form-textarea v-model="fields[item._id]" id="textarea-rows" placeholder="ຄຳຕອບ......" rows="4"></b-form-textarea>
                            {{fields[item._id]}}
                        </b-col>
                        <b-col cols="2" md="2" lg="2">
                            <b-button pill variant="outline-secondary" @click="onreply(item._id,index)">
                                <b-icon icon="reply"></b-icon> ຕອບກັບ</b-button>
                        </b-col>
                    </b-row>
                </b-card>
    
            </b-col>
        </b-row>
        <infinite-loading @infinite="infiniteHandler" spinner="spiral">
            <div slot="spinner">Loading...</div>
            <div slot="no-more">No more data</div>
            <div slot="no-results">No results data</div>
        </infinite-loading>
    
    </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment'
export default {
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
    },
    data() {
        return {
            page: 0,
            field: '',
            find: '',

            pkey: "",
            table: "",
            fields: [],
            items: [],

            findfied: [],
            user: []
        }
    },
    components: {
        InfiniteLoading,
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        onnewquestion() {
            this.$router.push("/newquestions?desc=ຄຳຖາມ")
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/FeedQuestion" +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find, {
                            headers: {
                                'Authorization': 'Bearer ' + this.user.login_hash
                            }
                        }
                    )
                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })
                            this.items = response.data.items;
                            this.page++;
                            $state.loaded();
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                            $state.loaded();
                        }
                    });

                this.busy = false;
            }, 200);
        },

        onreply(id, idx) {
            let rp_data = null;
            //console.log( idx)

            let postsdata = {
                _id: id,
                item: {
                    "answer": this.fields[id],
                    "create_by": this.user.username,
                    "create_date": new Date().toJSON()
                },
            };
            this.items[idx].answers.push(postsdata.item)

            axios
                .post(
                    this.$store.getters.getBaseUrl + "/replyanswer",
                    postsdata, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        console.log("Done")
                        //this.$router.go(0);
                        this.fields[id] = ""
                    }
                })

        }
    },
    filters:{
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
      },
    }

}
</script>

<style lang="">

</style>